/**
 * AP Ageing — Supplier ageing analysis.
 * Thin wrapper: locks party type to Supplier.
 */
import { AgeingPage } from '@/pages/fin/AgeingPage';

export const ApAgeingPage = () => (
  <AgeingPage defaultPartyType="Supplier" lockPartyType />
);
